export default __webpack_public_path__ + "static/media/Unity Bulwark.52e57141.png";